import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import AfitdTypography from '../../common/elemental/AfitdTypography';

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
    },
});

const FieldLabel = props => {
    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { children, ...otherProps } = props;

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <AfitdTypography variant="caption" {...otherProps}>
            {children}
        </AfitdTypography>
    );
};

export default withStyles(styles)(FieldLabel);
